module.exports = __webpack_public_path__ + "img/immigration-color@2x.e9b782e3.png";